import type { GlobalSearchFilterDescriptor } from '@common/types';

// One filter per searchable domain. The previous catalog split guests into four
// filters (unsubscribed / exception-listed / communications) that no seed or
// route could distinguish, so every one of them returned the guest list.
export enum GlobalSearchFilterId {
  Reports = 'reports',
  Guests = 'guests',
  Reviews = 'reviews',
  Questionnaires = 'questionnaires',
  ServiceTickets = 'service-tickets',
  Users = 'users',
  Settings = 'settings',
}

export const GLOBAL_SEARCH_FILTERS: readonly GlobalSearchFilterDescriptor[] = [
  { id: GlobalSearchFilterId.Reports, label: 'Reports', icon: 'summarize' },
  { id: GlobalSearchFilterId.Guests, label: 'Guests', icon: 'groups' },
  { id: GlobalSearchFilterId.Reviews, label: 'Reviews', icon: 'reviews' },
  { id: GlobalSearchFilterId.Questionnaires, label: 'Questionnaires', icon: 'fact_check' },
  { id: GlobalSearchFilterId.ServiceTickets, label: 'Service Tickets', icon: 'confirmation_number' },
  { id: GlobalSearchFilterId.Users, label: 'Users', icon: 'badge' },
  { id: GlobalSearchFilterId.Settings, label: 'My settings', icon: 'manage_accounts' },
];
